export const flexColumn  = () => {
    return `
        display: flex;
        flex-direction: column;
    `
}
export const flexCenter = () => {
    return `
        display: flex;
        align-items: center;
        justify-content: center;
    `
}
export const flexHorizontalCenter  = () => {
    return `
        display: flex;
        justify-content: center;
    `
}
export const flexVerticalCenter  = () => {
    return `
        display: flex;
        align-items: center;
    `
}
export const customFlex = (value1, value2) => {
    return `
        display: flex;
        justify-content: ${value1};
        align-items: ${value2};
    `
}